import { ArrowRight, CheckCircle2, FileText } from 'lucide-react';

import { Badge } from '@/components/common/Badge/Badge';
import { Button } from '@/components/common/Button/Button';
import { Card } from '@/components/common/Card/Card';
import { CandidateAvatar } from '@/components/common/CandidateAvatar/CandidateAvatar';
import type { Candidate } from '@/models/candidate';
import type { Proposal } from '@/models/proposal';
import { classNames } from '@/utils/classNames';

import styles from '@/styles/positions.module.css';

type CandidateProposalCardProps = {
  candidate: Candidate;
  proposal: Proposal;
  href: string;
  secondaryHref?: string;
  secondaryLabel?: string;
  className?: string;
};

export function CandidateProposalCard({
  candidate,
  proposal,
  href,
  secondaryHref,
  secondaryLabel = 'Ver fontes',
  className,
}: CandidateProposalCardProps): JSX.Element {
  const isMissing = proposal.status === 'not_found';

  return (
    <Card className={classNames(styles.proposalCard, isMissing && styles.proposalMuted, className)}>
      <div className={styles.proposalTop}>
        <CandidateAvatar alt={candidate.name} imageUrl={candidate.photoUrl} name={candidate.name} size="md" />
        <div>
          <p className={styles.proposalName}>{candidate.name}</p>
          <p className={styles.proposalParty}>{candidate.party}</p>
        </div>
      </div>

      <div>
        <p className={styles.proposalSummary}>{proposal.briefing}</p>
      </div>

      <div className={styles.proposalStatusRow}>
        {isMissing ? (
          <Badge tone="warning">
            <FileText size={12} />
            Sem resumo consolidado
          </Badge>
        ) : (
          <Badge tone="success">
            <CheckCircle2 size={12} />
            Resumo consolidado
          </Badge>
        )}
      </div>

      <div className={styles.proposalActions}>
        <Button to={href} variant="secondary" size="sm" fullWidth>
          <span>{isMissing ? 'Ver proposta' : 'Ver proposta por tema'}</span>
          <ArrowRight size={14} />
        </Button>

        {secondaryHref ? (
          <Button to={secondaryHref} variant="ghost" size="sm" fullWidth>
            <span>{secondaryLabel}</span>
          </Button>
        ) : null}
      </div>
    </Card>
  );
}
